import { useAppDispatch, useAppSelector } from "@/app_redux/hooks/root_hook";
import {
  TriggerKeysType,
  TriggerStatusTypes,
  setTriggerData,
  setTriggerStatus,
  togglerTriggerStatus,
} from "@/app_redux/reducers/trigger_reducer";
import { useInterval, useTimeout } from "@mantine/hooks";

const DEFAULT_TRIGGER_INTERVAL = 2000;
const DEFAULT_TRIGGER_TIMEOUT = 2000;

type TriggerFuncOptions = { triggerInterval?: number; triggerTimeout?: number };

export const useTriggers = (triggerId: TriggerKeysType, options?: TriggerFuncOptions) => {
  const triggers = useAppSelector((state) => state.triggers);
  const dispatch = useAppDispatch();

  // ti -> Trigger Interval
  const ti = useInterval(() => {
    dispatch(togglerTriggerStatus(triggerId));
  }, options?.triggerInterval ?? DEFAULT_TRIGGER_INTERVAL);

  // tti -> Triger Time Out Interval
  const tti = useTimeout(() => {
    dispatch(togglerTriggerStatus(triggerId));
    tti.clear();
  }, options?.triggerTimeout ?? DEFAULT_TRIGGER_TIMEOUT);

  const getData = () => {
    return triggers[triggerId].data;
  };

  const getStatus = () => {
    return triggers[triggerId].status;
  };

  const updateTriggerData = (data: any) => {
    dispatch(setTriggerData({ trigger: triggerId, data: data }));
  };

  const updateTriggerStatus = (status: TriggerStatusTypes) => {
    dispatch(
      setTriggerStatus({
        status: status,
        trigger: triggerId,
      }),
    );
  };

  const updateTriggerStatusAndToggleAfterDelay = (status: TriggerStatusTypes) => {
    dispatch(
      setTriggerStatus({
        status: status,
        trigger: triggerId,
      }),
    );
    tti.start();
  };

  const startInterval = () => {
    if (ti.active) return;
    ti.start();
  };

  const stopInterval = () => {
    if (!ti.active) return;
    ti.stop();
  };

  const triggerAfterDelay = () => {
    tti.start();
  };

  const toggle = () => {
    dispatch(togglerTriggerStatus(triggerId));
  };

  return {
    getData,
    getStatus,
    updateTriggerData,
    updateTriggerStatus,
    updateTriggerStatusAndToggleAfterDelay,
    startInterval,
    stopInterval,
    triggerAfterDelay,
    toggle,
  };
};
